import { useEffect, useRef, useState } from 'react';
import '../styles/NavMain.css'

import bars from '../assets/bars.svg';
import cross from '../assets/cross.svg';
import cv from  '../assets/CV_2026.pdf';
import { SocialNetworks } from './ui/SocialNetworks.jsx';

// Secciones que observa el menú para resaltar la actual.
// Las que no tienen enlace propio resaltan la sección anterior.
const SECTION_IDS = ["home", "about", "services", "skills", "projects", "experience", "education", "contact"];
const LINKED_TO = { skills: "services", education: "experience" };

export function NavMain(){

  const barRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const [current, setCurrent] = useState("home");

  // Barra de progreso de lectura y sombra del menú al bajar
  useEffect(() => {
    let waiting = false;

    const update = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const progress = max > 0 ? window.scrollY / max : 0;
      if (barRef.current) barRef.current.style.transform = `scaleX(${progress})`;
      setScrolled(window.scrollY > 10);
      waiting = false;
    }

    const onScroll = () => {
      if (waiting) return;
      waiting = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  // Sección visible en la mitad de la pantalla
  useEffect(() => {
    if (!("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setCurrent(entry.target.id);
      });
    }, { rootMargin: "-45% 0px -50% 0px" });

    SECTION_IDS.forEach((id) => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const active = LINKED_TO[current] || current;
  const linkClass = (id) => (active === id ? "nav-main-link is-current" : "nav-main-link");

  const showMenu = () => {
    const $btnMenu = document.querySelector(".menu-btn");
    const $menu = document.querySelector(".nav-main-menu");

    $btnMenu.firstElementChild.classList.toggle("none");
    $btnMenu.lastElementChild.classList.toggle("none");
    $menu.classList.toggle("is-active");

    document.addEventListener("click", (e) => {
      if(!e.target.matches(".nav-main-link")) return false;

      $btnMenu.firstElementChild.classList.remove("none");
      $btnMenu.lastElementChild.classList.add("none");
      $menu.classList.remove("is-active");
    })
  }

  return(
    <header className={scrolled ? "nav-main is-scrolled" : "nav-main"}>
      <div className="nav-main-content">

        <div className="nav-main-logo">
          <a href="#home">CB</a>
        </div>

        <button className="menu-btn" onClick={showMenu}>
          <img src={bars} alt="|" className="menu-btn-bars" />
          <img src={cross} alt="X" className="menu-btn-cross none" />
        </button>

        <nav className="nav-main-menu">
          <a href="#home" className={linkClass("home")}>INICIO</a>
          <a href="#about" className={linkClass("about")}>SOBRE MI</a>
          <a href="#services" className={linkClass("services")}>SERVICIOS</a>
          <a href="#projects" className={linkClass("projects")}>PROYECTOS</a>
          <a href="#experience" className={linkClass("experience")}>TRAYECTORIA</a>
          <a href="#contact" className={linkClass("contact")}>CONTACTO</a>
          <a href={cv} download className="nav-main-link" >CURRICULUM VITAE </a>

          <SocialNetworks />
        </nav>

        <SocialNetworks />
      </div>

      <div className="scroll-progress" ref={barRef} aria-hidden="true"></div>
    </header>
  );
}
